import React, { Component } from 'react'
import { Switch } from '@progress/kendo-react-inputs';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import Loader from '../Shared/Loader/loader';
import ErrorMessage from "../Shared/Error/ErrorMessage";
import { callApiWithAuthorization } from '../../API/CallApi';
import { RoleContext } from './Context/RoleContext';
import { SavingComponent, InProgressComponent } from "./SavingComponent";
import { GlobalContext } from "../../Renderers/GlobalContext"
import { withTranslation } from 'react-i18next';

class PageRights extends Component {

    static contextType = RoleContext

    constructor(props) {
        super(props)
    }

    componentDidMount = async () => {
        const { dispatch } = this.context
        let pages = await this.getPages()
        dispatch({ type: "SET_PAGES", payload: pages })
        dispatch({ type: "SET_PAGE_LOADER", payload: false })
        if (pages.length > 0) {
            this.selectItem(pages[0])
        }
    }

    componentDidUpdate = async (props) => {
        if (props.selectedEntity && props.selectedEntity._id !== this.props.selectedEntity._id) {
            const { dispatch } = this.context
            let pages = await this.getPages()
            dispatch({ type: "SET_PAGES", payload: pages })
            dispatch({ type: "SET_PAGE_LOADER", payload: false })
            if (pages.length > 0) {
                this.selectItem(pages[0])
            }
        }
    }

    render() {
        const { state } = this.context
        const { selectedEntity } = state
        const { t } = this.props
        if (state.loadingPages) return <Loader />
        return (
            <div className="py-2">
                {
                    state.pages.length === 0 ?
                        <ErrorMessage
                            valid={false}
                            error={t("error.no_data")}
                        />
                        :
                        <GlobalContext.Consumer>
                            {value => (
                                <Grid
                                    data={state.pages.map((item) => ({
                                        ...item,
                                        selected: item.id === state.selectedPage.id
                                    }))}
                                    onRowClick={(e) => this.selectItem(e.dataItem)}
                                    style={{ maxHeight: '100%' }}
                                    scrollable="true"
                                    selectedField="selected"
                                >
                                    <Column field="indexId" title="#" width={40} />
                                    <Column
                                        title={t("grid.header.name")}
                                        cell={(props) => (
                                            <td>
                                                <a target={"_blank"} href={`/${this.props.organization.orgName}/${this.props.projectName}/Entities/${selectedEntity.sysName}/Display/${props.dataItem.pageName}`}>
                                                    <span className="link">{props.dataItem.pageName}</span>
                                                </a>
                                            </td>
                                        )}
                                    />
                                    <Column
                                        width={60}
                                        title={t("grid.header.access")}
                                        cell={(props) => (
                                            <td>
                                                <Switch
                                                    disabled={this.ShouldAccessDisabled(props.dataItem) || value.state.subscription.rolesPermission === "Read only"}
                                                    checked={props.dataItem.access}
                                                    onChange={(e) => this.handleAccess(props.dataItem, e)}
                                                />
                                            </td>
                                        )}
                                    />
                                    <Column
                                        width={50}
                                        title=""
                                        cell={(props) => (
                                            <td>
                                                {state.pageInProgressItems.includes(props.dataItem.id) && <InProgressComponent />}
                                                {state.pageSavedItems.includes(props.dataItem.id) && <SavingComponent />}
                                            </td>
                                        )}
                                    />
                                </Grid>
                            )}
                        </GlobalContext.Consumer>
                }
            </div>
        )
    }

    getPages = async () => {
        const { selectedEntity, selectedRole } = this.context.state
        let request = await callApiWithAuthorization("/api/v0/entity/" + selectedEntity._id + "/role/" + selectedRole._id + "/pageRole")
        let pages = await request.json()
        pages = pages.sort((a, b) => a.order - b.order)
        pages.forEach((page, index) => page.indexId = index + 1)
        pages = pages.filter(page => page.subPageType !== "List")
        return pages
    }

    selectItem = (dataItem) => {
        const { dispatch } = this.context
        dispatch({ type: "SET_SELECTED_PAGE", payload: dataItem })
    }

    ShouldAccessDisabled = (page) => {
        const { state } = this.context
        const { selectedEntity, selectedRole } = state
        const entityRights = selectedEntity.roleRights[selectedRole._id]
        if (state.pageInProgressItems.includes(page.id)) {
            return true
        }
        if (
            entityRights.create &&
            entityRights.read &&
            entityRights.update &&
            entityRights.delete
        ) {
            return false
        } else if (
            !entityRights.create &&
            entityRights.read &&
            !entityRights.update &&
            !entityRights.delete
        ) {
            if (page.pageName === "New Record" || page.pageName === "Edit Record") {
                return true
            } else {
                return false
            }
        } else if (
            !entityRights.create &&
            !entityRights.read &&
            !entityRights.update &&
            !entityRights.delete
        ) {
            return true
        } else {
            return false
        }
    }

    handleAccess = async (page, dataItem) => {
        const { state, dispatch } = this.context
        const { selectedRole } = state
        dispatch({ type: "PAGE_ADD_TO_INPROGRESS", payload: page.id })
        const request = await callApiWithAuthorization("/api/v0/role/" + selectedRole._id + "/page/" + page.id, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                access: dataItem.value
            })
        })
        const response = await request.json();
        dispatch({ type: "UPDATE_PAGES", payload: { id: page.id, properties: { access: dataItem.value } } })
        dispatch({ type: "PAGE_MOVE_TO_SAVE", payload: page.id })
        this.selectItem({ ...page, access: dataItem.value })
    }
}

export default withTranslation([
    "role/display_pages_rights",
], {
    withRef: true,
})(PageRights);
